require('./fonts.css');

require('./main.css');

import colours from './colours';
import grid from './grid';
import fonts from './fonts';
import spacing from './spacing';
import styles from './styles';
import states from './states';
import mediaQueries from '../helpers/mediaQueries';
export default {
  colours: colours,
  fonts: fonts,
  spacing: spacing,
  media: mediaQueries(grid.breakpoints),
  styles: styles,
  grid: grid,
  states: states
};